import { IEquipment } from '@/pages/Equipment/equipment.types'
import parametersSelectors from '@/pages/Parameters/parameters.selectors'
import { useRecoilValue } from 'recoil'
import LiftIndicatorsWidget from '../LiftIndicatorsWidget'
import useParametersValues from '@/services/data/hooks/useParametersValues'
import liftIndicatorsConfig from '../liftIndicators.config'
import { useMemo } from 'react'

interface IProps {
  equipmentId: IEquipment['id']
  live: boolean
  ts: number // unix ts in ms
}

const LiftIndicatorsRealtime = (props: IProps) => {
  const sourceIdToIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)

  const parameters = useMemo(
    () => liftIndicatorsConfig.indicatorsParameters.map((e) => sourceIdToIdMap[e]),
    [sourceIdToIdMap]
  )

  const valuesCtrl = useParametersValues({
    equipmentId: props.equipmentId,
    parameters,
    live: props.live,
    ts: props.ts,
  })

  return <LiftIndicatorsWidget values={valuesCtrl.values} loading={valuesCtrl.loading} />
}

export default LiftIndicatorsRealtime
